import { createContext, PropsWithChildren, useState, useEffect, useCallback } from 'react';

export const ForterContext = createContext<{ forterTokenCookie: string } | null>(null);

// TODO: move to env variable
const FORTER_ID = process.env.REACT_APP_ENV === 'prod' ? '2d4f889367f8' : '165eac0f0f3e';

export const ForterProvider = ({ children }: PropsWithChildren) => {
  const [token, setToken] = useState<string>('');

  const loadForterScript = useCallback(() => {
    const script = document.createElement('script');
    script.id = FORTER_ID;
    script.src = '/scripts/forter.js';
    script.setAttribute('data-siteId', FORTER_ID);
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    loadForterScript();
    const eventListener = (e: any) => {
      const token = e.detail;
      setToken(token);
    };

    document.addEventListener('ftr:tokenReady', eventListener);
    return () => {
      document.removeEventListener('ftr:tokenReady', eventListener);
    };
  }, [loadForterScript]);

  return (
    <ForterContext.Provider value={{ forterTokenCookie: token }}>{children}</ForterContext.Provider>
  );
};
